const path = require('path');

export const directoryPath = {
    mails: path.join(global.appRoot,  global.isProd ? "buildServer/server/models/edf-in/templates/mails" : "src/server/models/edf-in/templates/mails"),
    pdfs: path.join(global.appRoot,  global.isProd ? "buildServer/server/models/edf-in/templates/pdfs" : "src/server/models/edf-in/templates/pdfs")
}